import { createFileRoute } from '@tanstack/react-router';
import { WorkOrderDetailPage } from '@/features/work-orders/components/WorkOrderDetailPage';

export const Route = createFileRoute('/_authenticated/work-orders/$id/')({
	component: WorkOrderDetail,
});

function WorkOrderDetail() {
	const { id } = Route.useParams();
	return <WorkOrderDetailPage id={id} />;
}
